
import { payAccountcheck } from '@/api'

const state = {
    account: null
}

const mutations = {
    updateAccount(state, data) {
        state.account = data
    }
}

const actions = {
    async updateAccountAsync({ commit }, callback) {
        try {
            const { code, result} = await payAccountcheck()
            if (code === 0) {
                commit('updateAccount', result)
                callback?.(true)
            } else {
                commit('updateAccount', null)
                callback?.(false)
            }
        } catch (e) {
            commit('updateAccount', null)
            callback?.(false)
        }        
    }
}

export default {
    state,
    mutations,
    actions
}

